<mat-nav-list class="adminSidebar">
  <div class="navigation">
    <div class="profile-card">
      <div class="header font">
        <h2 class="font">{{ admin.firstName }} {{ admin.lastName }}</h2>
        <h4 class="font" style="color: #14abf9">@if (admin.isAdmin == true) {
          <span>
              <span>Republički geodetski zavod</span>

          </span>
          }@if (admin.isAdmin == false) {
          <span>Trener kompanija</span>
        }</h4>
        <h4 class="font">{{ admin.email }}</h4>
      </div>

    </div>
    <mat-divider></mat-divider>
    <!-- <h2 matSubheader>Pages</h2> -->
    <a mat-list-item [class]="dashboardClass" class="font whiteText"  (click)="changeClass('dashboard')" routerLink="/admin">
      <mat-icon [class]="dashboardClass" class="sidebarIcons">home</mat-icon>
      <span class="whiteText">{{ labels.lblDashBoard }}</span></a>
      @if (admin.isAdmin == true) {
        <a mat-list-item [class]="usersClass" class="font" (click)="changeClass('user')"
          routerLinkActive="list-item-active" routerLink="/admin/users">
          <div class="whiteText" style="width: 100%;">
            <mat-icon [class]="usersClass" class="sidebarIcons">people</mat-icon>
            <span class="whiteText">{{ labels.lblUsers }}</span>
            @if (!usersExpanded) {
              <mat-icon style="float: right; margin-right: 0px;">expand_more</mat-icon>
            }
            @if (usersExpanded) {
              <mat-icon style="float: right; margin-right: 0px;">expand_less</mat-icon>
            }
          </div>
        </a>
      }
      @if (usersExpanded) {
        <a mat-list-item [class]="administratorsClass" class="font" (click)="changeClass('administrators')"
          routerLink="/admin/administrators">
          <div class="whiteText menuItem">{{ labels.lblAdministrators }}</div>
        </a>
      }
      @if (usersExpanded) {
        <a mat-list-item [class]="sectorsGroupsClass" class="font" (click)="changeClass('sectorsGroups')"
          routerLink="/admin/departments">
          <div class="menuItem whiteText">{{ labels.lblSectors }}</div>
        </a>
      }
      @if (usersExpanded) {
        <a mat-list-item [class]="trainersClass" class="font" (click)="changeClass('trainers')"
          routerLink="/admin/trainers">
          <div class="menuItem whiteText">{{ labels.lblTrainers }}</div>
        </a>
      }
      @if (admin.isAdmin == false) {
        <a mat-list-item [class]="trainersClass" class="font" (click)="changeClass('trainers')"
          routerLink="/admin/trainers">
          <div>
            <mat-icon [class]="trainersClass" class="sidebarIcons">people</mat-icon>
            <span class="whiteText">{{ labels.lblTrainers }}</span>
          </div>
        </a>
      }
      <a mat-list-item [class]="trainingsClass" class="font" (click)="changeClass('trainings')"
        routerLinkActive="list-item-active" routerLink="/admin/trainings">
        <div class="whiteText" style="width: 100%;">
          <mat-icon [class]="trainingsClass" class="sidebarIcons">subject</mat-icon>
          <span class="whiteText">{{ labels.lblEtraining }}</span>
          @if (!trainingsExpanded) {
            <mat-icon style="float: right; margin-right: 0px;">expand_more</mat-icon>
          }
          @if (trainingsExpanded) {
            <mat-icon style="float: right; margin-right: 0px;">expand_less</mat-icon>
          }
        </div>
      </a>
      @if (trainingsExpanded) {
        <a mat-list-item [class]="testSurveyClass" class="font" (click)="changeClass('testSurvey')"
          routerLink="/admin/tests">
          <div class="menuItem whiteText">{{ labels.lblTest }}/{{ labels.lblSurvey }}</div>
        </a>
      }
      @if (trainingsExpanded) {
        <a mat-list-item [class]="foldersClass" class="font" (click)="changeClass('folders')"
          routerLink="/admin/trainings/folders">
          <div class="menuItem whiteText"><span class="whiteText">{{ labels.lblFolders }}</span></div>
        </a>
      }
      <!-- <a mat-list-item [class]="departmentsClass" class="font" (click)="changeClass('departments')" routerLinkActive="list-item-active" routerLink="/admin/departments"><mat-icon [class]="departmentsClass" class="sidebarIcons">work_outline</mat-icon>{{labels.lblSectors}}</a>-->
      <!--<a mat-list-item [class]="testsClass" class="font" (click)="changeClass('tests')" routerLinkActive="list-item-active" routerLink="/admin/tests"><mat-icon [class]="testsClass" class="sidebarIcons">assignment</mat-icon>{{labels.lblTests}}</a>-->
      <a mat-list-item [class]="generateReportsClass" class="font" style="margin-top: 1vh;"
        (click)="changeClass('generateReports')" routerLinkActive="list-item-active"
        routerLink="/admin/generate-reports">
        <mat-icon [class]="generateReportsClass" class="sidebarIcons">insert_drive_file</mat-icon>
        <span class="whiteText">{{ labels.lblReports }}</span></a>



          </div>
        </mat-nav-list>
